import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import ShowEmailMsg from "./showEmailMsg.vue";
import { getEmail } from "@/api/data";
import { getUserInfoMap } from "@/utils/dictionary";
export default {
  name: "showEmailTable",
  components: {
    ShowEmailMsg: ShowEmailMsg
  },
  props: {
    tableInfo: Array
  },
  data: function data() {
    return {
      emailStatus: {
        1: "待审核",
        2: "审核驳回",
        3: "审核通过",
        4: "发送成功",
        5: "发送失败"
      },
      classStatus: {
        1: "notApproved",
        2: "FailApproved",
        3: "Approved",
        4: "sendSuccess",
        5: "FailSend"
      },
      //获取所有角色列表（申请人与审批人）
      UserInfoList: "",
      //点击表格的查看邮件的返回接收,弹出框
      dialogFormVisible: false,
      if_dialogFormVisible: false,
      //传给查看的每一行数据
      formData: {},
      //点击查看邮件类型，1个人，2单服
      openEmailType: 0,
      //true就是点击了编辑（只有审核失败，才有这个按钮出现）
      isEditPage: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              res = _context.sent;
              _this.UserInfoList = res;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //点击表格的查看邮件
    checkEmailBtn: function checkEmailBtn(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getEmail({
                email_id: row.email_id
              });
            case 2:
              res = _context2.sent;
              //判断是个人邮件还是单服邮件，查看显示的不一样
              if (row.email_type === 1) {
                _this2.openEmailType = 1;
              } else {
                _this2.openEmailType = 2;
              }
              _this2.formData = res.data.data;
              _this2.if_dialogFormVisible = true;
              _this2.dialogFormVisible = true;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //个人邮件页面点击编辑
    EditEmailBtn: function EditEmailBtn(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getEmail({
                email_id: row.email_id
              });
            case 2:
              res = _context3.sent;
              if (row.email_type === 1) {
                _this3.openEmailType = 1;
              } else {
                _this3.openEmailType = 2;
              }
              data = {
                isEditPage: true,
                //代表”编辑“
                openEmailType: _this3.openEmailType,
                //单服&个人
                formInfo: res.data.data //当前行信息
              };

              _this3.$emit("sendData", data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};